export default __webpack_public_path__ + "static/media/86_photo.e4e15c6b.jpg";